import { FootballMatchFormConfigFields } from './Football';
import { RugbyLeagueMatchFormConfigFields } from './RugbyLeague';
import { RugbyUnionMatchFormConfigFields } from './RugbyUnion';

export const MatchFormConfigFields: { [key: string]: any } = {
  football: FootballMatchFormConfigFields,
  'rugby league': RugbyLeagueMatchFormConfigFields,
  'rugby union': RugbyUnionMatchFormConfigFields
};
